import { FC } from 'react';

import FormFieldRenderer from '../FormFieldRenderer';

import { Props } from './types';

const SchemaFormRenderer: FC<Props> = ({ fields }) => {
  return fields.map((field) => (
    <FormFieldRenderer key={field.name} field={field} />
  ));
};

export default SchemaFormRenderer;
